import checkIcon from 'assets/icons/check.svg';

type TasksProgressBarProps = {
  progress?: number;
  maxProgress?: number;
};

export const TasksProgressBar = ({ progress: rawProgress = 0, maxProgress: rawMax = 100 }: TasksProgressBarProps) => {
  const maxProgress = Math.max(1, rawMax);
  const progress = Math.min(Math.max(0, rawProgress), maxProgress);
  const percent = Math.min((progress / maxProgress) * 100, 100);
  const isSmall = progress <= 1;
  const isComplete = percent >= 100;

  return (
    <div className="tw-flex tw-items-center tw-gap-[20px] tw-font-jost">
      <div
        className="tw-flex tw-h-[42px] tw-w-full tw-items-center tw-rounded-[20px] tw-border tw-border-solid tw-border-[#2D5EFF] tw-px-[8px]"
        style={{ boxShadow: '5px 5px 0px 0px rgba(45, 94, 255, 0.4)' }}
      >
        <div
          className="tw-flex tw-h-[27px] tw-items-center tw-justify-end tw-rounded-[68px]"
          style={{
            background: 'linear-gradient(to right, #FF0F43 0%, #F16754 50%, #1FA564 100%)',
            backgroundSize: `${(100 / (percent || 1)) * 100}% 100%`,
            backgroundPosition: 'left',
            width: `max(27px, ${percent}%)`,
            minWidth: '27px',
          }}
        >
          {isComplete ? (
            <img src={checkIcon} alt="complete" className="tw-mr-[2px] tw-h-[24px] tw-w-[24px] tw-shrink-0" />
          ) : (
            <div
              className={`tw-mr-[2px] tw-flex tw-h-[23px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-border tw-border-solid tw-border-white ${
                isSmall ? 'tw-w-[23px]' : 'tw-px-[8px]'
              }`}
            >
              <span className="tw-whitespace-nowrap tw-text-[18px] tw-font-semibold tw-text-white">{progress}</span>
            </div>
          )}
        </div>
      </div>

      <span className="tw-text-[18px] tw-font-semibold tw-text-white">{maxProgress}</span>
    </div>
  );
};
